'use client';

import dynamic from 'next/dynamic';

const HtmlEmbed = dynamic(() => import('./html-embed').then((m) => ({ default: m.HtmlEmbed })), {
  ssr: false,
});

export default HtmlEmbed;
